import React from "react";
import { Locale } from "@linkfluence/models/locale";
import PageError from "@radarly/components/error-boundary/page";

interface ErrorPageLayoutProps {
  url?: string;
}

export default function ErrorPageLayout({ url = "/" }: ErrorPageLayoutProps) {
  const locale = Locale.English;
  return <PageError locale={locale} url={url} />;
}
